module.exports = "https://la-static.prod-my.games/minigames/collection/img/check.3226140e.svg";